import React, {useState, useEffect} from "react"
import {observer} from "mobx-react-lite"
import {stateCode, dmaCode} from "../../utils/stateDMACode"
import {GEOTYPE} from "../../utils/utils"
import "./index.scss"
import {UseStores} from "../../hooks/UseStores"

const initGeo = {geoType: "COUNTRY", geoId: 0, geoName: "US"}

const MapNavigation = ({geoObj, handleUpdate}) => {
  const {gtMapStore} = UseStores()
  const [locations, setLocations] = useState([initGeo])
  const currentPage = window.location.pathname

  useEffect(() => {
    handleCreateMapBreadCrumb(geoObj)
  }, [JSON.stringify(geoObj)]) //reset map breadcrumb on route change - first render
  //stringify geoObj to detect change in its contents

  const handleMapUpdate = (location, idx) => {
    if (idx !== locations.length - 1) {
      const locationObj = {geoType: location.geoType, geoId: location.geoId}
      handleCreateMapBreadCrumb(locationObj)
    }
  }

  const handleCreateMapBreadCrumb = (geo) => {
    const listArr = []
    let obj

    if (geo !== null) {
      if (geo.geoType === GEOTYPE.DMA) {
        try {
          obj = dmaCode.find((obj) => obj.id === geo.geoId)

          listArr.push(
            {
              geoType: GEOTYPE.COUNTRY,
              geoId: obj.countryId,
              geoName: obj.country,
            },
            {
              geoType: GEOTYPE.STATE,
              geoId: obj.stateId,
              geoName: obj.state,
            },
            {
              geoType: GEOTYPE.DMA,
              geoId: obj.id,
              geoName: obj.dma,
            }
          )

          handleUpdate(geo, window.location.pathname)
        } catch (err) {
          console.error(err)
        }
      } else if (geo.geoType === GEOTYPE.STATE) {
        try {
          obj = stateCode.find((obj) => obj.id === geo.geoId)

          listArr.push(
            {
              geoType: GEOTYPE.COUNTRY,
              geoId: obj.countryId,
              geoName: obj.country,
            },
            {
              geoType: GEOTYPE.STATE,
              geoId: obj.id,
              geoName: obj.state,
            }
          )

          handleUpdate(geo, window.location.pathname)
        } catch (err) {
          console.error(err)
        }
      } else {
        listArr.push(initGeo)
        handleUpdate(geo, window.location.pathname)
      }
      setLocations(listArr)
      gtMapStore.setLocation(listArr)
    }
  }

  const mapLinks = (
    <ul>
      {locations.map((location, idx) => {
        return (
          <li key={location.geoType}>
            <p onClick={() => handleMapUpdate(location, idx)}>{location.geoName}</p>
            <span className="chevron-right"></span>
          </li>
        )
      })}
    </ul>
  )

  return (
    <>
      {!currentPage.includes("locations") && (
        <div id="mapNav-container" data-testid="mapNav-container-test">
          <div className="header">{mapLinks}</div>
        </div>
      )}
    </>
  )
}
export default observer(MapNavigation)
